<template>
  <el-dialog custom-class="transformer-setting-container dialog-size-middle"
             :title="transformerSummary.transformerName"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="transformer-setting-sub-title">{{transformerSummary.description.text}}</div>
    <div class="transformer-setting-body">
      <form-container>
        <form-item-container v-if="hyperParams && hyperParams.length > 0" label="変換設定"
                             annotation="* 不明な場合は値を変更しなくて構いません">
          <hyper-params ref="hyperParams" :hyperParams="hyperParams"
                        :hyperParamSummaries="transformerSummary.hyperParams"></hyper-params>
        </form-item-container>
      </form-container>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSetting">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import HyperParamsCmp from '../../../form/field/hyper-params.vue'

export default {
  name: 'TransformerSettingCmp',
  components: {
    'hyper-params': HyperParamsCmp
  },
  props: {
    transformer: {},
    transformerSummary: {}
  },
  data () {
    return {
      hyperParams: [],
      visible: true
    }
  },
  created () {
    for (const srcHyperParam of this.transformer.hyperParams) {
      this.hyperParams.push({
        hyperParamId: srcHyperParam.hyperParamId,
        value: srcHyperParam.value
      })
    }
  },
  methods: {
    onClickSetting () {
      this.$refs.hyperParams.$validator.validateAll().then((result) => {
        if (result) {
          this.visible = false
          this.$set(this.transformer, 'hyperParams', this.hyperParams)
          this.$emit('setting', this.transformer)
        }
      })
    }
  }
}

</script>

<style type="scss" scoped>
  .transformer-setting-sub-title {
    font-size: 14px;
    margin-bottom: 1.25em;
  }

  .transformer-setting-body {
    overflow-y: scroll;
    height: 100%;
  }

  .el-dialog__wrapper > > > .transformer-setting-container .el-dialog__header {
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/train/dialogs/transformer-setting.vue